import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collectionGroup, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export default function LatestAlertsPage() {
    const navigate = useNavigate();
    const [alerts, setAlerts] = useState([]);
    const [loading, setLoading] = useState(true);

    const parseDate = (value) => {
        if (!value) return null;
        if (value._seconds) return new Date(value._seconds * 1000);
        if (value.toDate) return value.toDate();
        if (typeof value === 'string') return new Date(value);
        return new Date(value);
    };

    useEffect(() => {
        const loadAlerts = async () => {
            try {
                // Chronological fetch of the 50 most recent global alerts
                const q = query(collectionGroup(db, 'emergencyAlerts'), orderBy('time', 'desc'), limit(50));
                const snap = await getDocs(q);
                
                const data = snap.docs.map(doc => ({
                    id: doc.id,
                    serverId: doc.ref.parent.parent?.id,
                    ...doc.data()
                }));
                setAlerts(data);
            } catch (error) {
                console.error("Failed to load alerts:", error);
            } finally {
                setLoading(false);
            }
        };
        loadAlerts();
    }, []);

    if (loading) return <div style={{ padding: '40px', textAlign: 'center' }}>Fetching Global Alert History...</div>;

    return (
        <div style={{ padding: '40px', backgroundColor: '#f4f6f8', minHeight: '100vh' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '30px' }}>
                <button onClick={() => navigate('/dashboard')} style={{ marginRight: '20px', padding: '8px 16px', border: '1px solid #ddd', borderRadius: '4px', background: 'white', cursor: 'pointer' }}>← Dashboard</button>
                <div>
                    <h1 style={{ margin: 0, fontSize: '24px', color: '#c53030' }}>Global Emergency Alert Log</h1>
                    <p style={{ margin: '5px 0 0', color: '#666', fontSize: '14px' }}>Chronological feed of all platform alerts.</p>
                </div>
            </div>

            <div style={{ display: 'grid', gap: '15px' }}>
                {alerts.length === 0 ? <div style={{ color: '#718096' }}>No alerts found on the platform.</div> : 
                    alerts.map(alert => {
                        // Extract Lat/Lng safely if it exists
                        const lat = alert.location?._latitude || alert.location?.latitude;
                        const lng = alert.location?._longitude || alert.location?.longitude;
                        const hasLocation = lat && lng;

                        return (
                        <div key={alert.id} style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', borderLeft: `4px solid ${alert.priority === 'high' ? '#e53e3e' : '#ecc94b'}`, boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <div>
                                    <h3 style={{ margin: '0 0 5px 0', color: '#2d3748', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        {alert.fullName || alert.username || 'Emergency Alert'}
                                        {alert.isClosed ? 
                                            <span style={{ fontSize: '11px', background: '#e2e8f0', padding: '2px 6px', borderRadius: '4px', color: '#718096' }}>Closed</span> : 
                                            <span style={{ fontSize: '11px', background: '#fed7d7', padding: '2px 6px', borderRadius: '4px', color: '#c53030' }}>Active</span>
                                        }
                                    </h3>
                                    
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginTop: '10px', fontSize: '13px', color: '#4a5568' }}>
                                        <div><strong>Server:</strong> {alert.serverId}</div>
                                        <div><strong>Phone:</strong> {alert.phoneNumber || 'N/A'}</div>
                                        <div><strong>Type:</strong> {alert.type}</div>
                                        <div><strong>Priority:</strong> <span style={{ textTransform: 'capitalize', color: alert.priority === 'high' ? '#e53e3e' : 'inherit' }}>{alert.priority}</span></div>
                                        
                                        {hasLocation && (
                                            <div style={{ gridColumn: 'span 2' }}>
                                                <strong>Location:</strong> <a href={`https://maps.google.com/?q=${lat},${lng}`} target="_blank" rel="noreferrer" style={{ color: '#3182ce', textDecoration: 'none' }}>View on Maps ({lat.toFixed(4)}, {lng.toFixed(4)})</a>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div style={{ textAlign: 'right' }}>
                                    <span style={{ fontSize: '12px', color: '#a0aec0', background: '#f7fafc', padding: '4px 8px', borderRadius: '4px', display: 'block', marginBottom: '8px' }}>
                                        {parseDate(alert.time)?.toLocaleString()}
                                    </span>
                                    {alert.read && <span style={{ fontSize: '11px', color: '#38a169', fontWeight: 'bold' }}>✓ Read</span>}
                                </div>
                            </div>
                            <button 
                                onClick={() => navigate(`/servers/${alert.serverId}/emergency-alerts`)}
                                style={{ marginTop: '15px', padding: '8px 16px', backgroundColor: '#fff5f5', color: '#c53030', border: '1px solid #fed7d7', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold' }}
                            >
                                Open Server Alert Log
                            </button>
                        </div>
                    )})}
            </div>
        </div>
    );
}